import { Output, EventEmitter, Injectable } from '@angular/core';
import { ITab } from './tab.model';

/**
 * the thing that knows about all the tabs
 */
@Injectable()
export class TabsController {
  public _allTabs: ITab[] = [];
  public _tabsInOrder: ITab[] = [];
  public isOnFirstTab: boolean = false;
  public isOnLastTab: boolean = false;
  @Output() public tabChange: EventEmitter<void> = new EventEmitter<void>();
  @Output() public tabEnableChange: EventEmitter<void> = new EventEmitter<void>();

  public select(tab: ITab): void {
    if (!tab || !tab.enabled) return;

    // if has tabs, select first tab
    if (tab.tabs && tab.tabs.filter(x => x.enabled).length) return this.select(tab.tabs.filter(x => x.enabled)[0]);

    let selectedTabs = [tab];

    // select
    tab.selected = true;

    // select all ancestors
    var parent = tab.parentTab;

    while (parent) {
      selectedTabs.push(parent);
      parent.selected = true;
      parent = parent.parentTab;
    }

    // deselect the rest
    this._allTabs.filter(x => selectedTabs.indexOf(x) < 0 && tab.selected).forEach(x => (x.selected = false));

    this.updateIsOnFirstLastTab();
    this.tabChange.emit();
  }

  /**
   * expensive
   */
  private updateIsOnFirstLastTab(): void {
    let tab: ITab = this._allTabs.find(x => x.selected == true);

    if (tab == null) return;

    // get the top most parent tab to figure out if we're on the first selectable tab
    var topMostAncestor = tab;

    while (topMostAncestor.parentTab) topMostAncestor = topMostAncestor.parentTab;

    let allEnabledTabsInOrder: ITab[] = this._tabsInOrder.filter(x => x.enabled && !x.isTabWellContent);
    let i: number = allEnabledTabsInOrder.indexOf(tab);

    this.isOnFirstTab = 0 == allEnabledTabsInOrder.indexOf(topMostAncestor);
    this.isOnLastTab = i == allEnabledTabsInOrder.length - 1;
  }

  /**
   * Lets the controller know about a tab
   * @param tab
   */
  public addTab(tab: ITab): void {
    // don't keep track of non tab tabs
    if (tab.isTabWellContent) return;

    this._allTabs.push(tab);
    this._tabsInOrder = this._getAllTabsAndSubsInOrder();
  }

  /**
   * Only enabled tabs
   */
  public getAllTabs() {
    return this._allTabs;
  }

  /**
   * Only enabled tabs
   */
  public getAllTabsAndSubsInOrder() {
    return this._tabsInOrder.filter(x => !x.isTabWellContent);
  }

  /**
   * Only enabled tabs
   */
  public _getAllTabsAndSubsInOrder() {
    let tabs: ITab[] = [];

    this._allTabs
      .filter(x => !x.parentTab)
      .forEach((t: ITab) => {
        tabs.push(t);
        this.getAllSubTabs(t).forEach((childT: ITab) => tabs.push(childT));
      });

    return tabs;
  }

  /**
   * Only enabled tabs
   */
  public getAllSubTabs(tab: ITab): ITab[] {
    if (!tab || !tab.tabs) return [];

    let tabs: ITab[] = [];

    tab.tabs.forEach((t: ITab) => {
      tabs.push(t);
      this.getAllSubTabs(t).forEach((childT: ITab) => tabs.push(childT));
    });

    return tabs;
  }

  /**
   * expensive. helper.
   */
  public triggerEnableChanged() {
    this.updateIsOnFirstLastTab();
    this.tabEnableChange.emit();
  }
}
